import { Dayjs } from 'dayjs'

export type GetPrositionFromStopArgs = {
  time: Dayjs
  startHour: number
  zoom: number
  baseWidth: number
}

export const getPositionFromTime = ({
  time,
  startHour,
  zoom,
  baseWidth,
}: GetPrositionFromStopArgs): number => {
  const hours = time.hour()
  const minutes = time.minute()

  // Calculate how many full intervals from start hour
  let hoursSinceStart = hours - startHour

  if (hoursSinceStart < 0) {
    hoursSinceStart += 24 // Handle wrap around midnight
  }

  const basePosition = hoursSinceStart * (baseWidth * zoom)
  const minutePosition = (minutes / 60) * (baseWidth * zoom)

  return basePosition + minutePosition
}